/** @note override console.log with an empty function in production mode */
if (process.env.NODE_ENV === 'production') console.log = function () {};
